import { defineComponent as n, createBlock as c, openBlock as t, unref as l, mergeProps as a, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const v = /* @__PURE__ */ n({
  name: "IconCurrencyDollar",
  __name: "IconCurrencyDollar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const o = r;
    return (i, e) => (t(), c(l(u), a(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M12.75 3a.75.75 0 0 0-1.5 0v1.292C10.384 4.39 9.533 4.66 8.834 5.126 7.911 5.741 7.25 6.709 7.25 8c0 1.342.746 2.206 1.68 2.791.674.424 1.51.742 2.32 1.028v6.38c-1.848-.256-3-1.446-3-2.699a.75.75 0 0 0-1.5 0c0 2.345 2.083 3.933 4.5 4.208V21a.75.75 0 0 0 1.5 0v-1.292c2.417-.275 4.5-1.863 4.5-4.208 0-1.51-.663-2.562-1.615-3.309-.836-.655-1.9-1.081-2.885-1.434V5.804c.604.09 1.157.285 1.584.57C14.911 6.759 15.25 7.291 15.25 8a.75.75 0 0 0 1.5 0c0-1.29-.661-2.259-1.584-2.874-.699-.466-1.55-.736-2.416-.834V3m-1.5 2.804c-.604.09-1.157.285-1.584.57C9.089 6.759 8.75 7.291 8.75 8c0 .658.317 1.107.977 1.52.425.267.94.486 1.523.704v-4.42m1.5 6.552V18.2c1.848-.256 3-1.446 3-2.699 0-.99-.4-1.626-1.041-2.129-.522-.409-1.195-.722-1.959-1.015",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
